import { render, staticRenderFns } from "./news-hot.vue?vue&type=template&id=2e3fff08&scoped=true"
import script from "./news-hot.vue?vue&type=script&lang=js"
export * from "./news-hot.vue?vue&type=script&lang=js"
import style0 from "./news-hot.vue?vue&type=style&index=0&id=2e3fff08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3fff08",
  null
  
)

export default component.exports